import React from 'react';
import { Card } from '../../../_shared/components/Card/Card';
import { Button } from '../../../_shared/components/Button/Button';
import { FactsInputTableDesktop } from './FactsInputTableDesktop';
import { FactsInputTableMobile } from './FactsInputTableMobile';
import { KpiTableProps } from './types';
import styles from './FactsInputTable.module.scss';

export function FactsInputTable(props: KpiTableProps) {
  return (
    <Card>
      <div className={styles.wrapper}>
        <div className={styles.desktop}>
          <FactsInputTableDesktop {...props} isDeleted={props.isDeleted} />
        </div>
        <div className={styles.mobile}>
          <FactsInputTableMobile {...props} isDeleted={props.isDeleted} />
        </div>
        <Button variant={'primary'} className={styles.button}>
          Отправить на ознакомление
        </Button>
      </div>
    </Card>
  );
}
